import * as Yup from 'yup';

export default Yup.object().shape({
  players: Yup.array(
    Yup.object().shape({
      name: Yup.string().required(),
    })
  ),
})
